import {kapitelDateTimeString} from "@/graphql/kapitelTypes";
import datetime, {kapitelDateTimeFormatTime} from "@/helper/datetime/datetime";

const formatTimeRange = (
    begin: kapitelDateTimeString,
    until: kapitelDateTimeString,
    format = kapitelDateTimeFormatTime,
    divider : ' bis ' | '&ndash;' | string = ' bis '
) => datetime.formatTime(begin, format) + divider + datetime.formatTime(until, format)

const formatTimeRangeObject = (
    object: {begin:kapitelDateTimeString, until:kapitelDateTimeString},
    format = kapitelDateTimeFormatTime,
    divider : ' bis ' | '&ndash;' | string = ' bis '
) => formatTimeRange(object.begin, object.until, format, divider);

export default {
    formatTimeRange,
    formatTimeRangeObject
}
